import React from 'react'
import { NativeStackNavigationOptions } from '@react-navigation/native-stack'

import { ROUTES } from './types'
import {
  ROUTES as FARMER_360_ROUTES,
  SCREEN_NAMES as FARMER_360_SCREEN_NAMES,
} from 'app/farmer360/routes/types'

import Farmer360Home from 'app/farmer360/screens/farmer360'
import EditFarmerInfo from 'app/farmer360/screens/editFarmerInfo'
import AddFarmerInfo from 'app/farmer360/screens/addFarmerInfo'
import OrdersListing from 'app/farmer360/screens/ordersListing'
import OngoingCropsListing from 'app/farmer360/screens/ongoingCropsListing'
import FarmerProductListing from 'app/farmer360/screens/farmerProductsListing'
import StartDiagnosis from 'app/farmer360/image-diagnosis/screens/StartDiagnosis'
import DiseaseDiagnosisScreen from 'app/farmer360/image-diagnosis/screens/DiseaseDiagnosisScreen'
import DiseaseTreatment from 'app/farmer360/image-diagnosis/screens/DiseaseTreatment'
import DiagnosisResult from 'app/farmer360/image-diagnosis/screens/DiagnosisResult'
import PreviousDiagnosis from 'app/farmer360/image-diagnosis/screens/PreviousDiagnosis'
import AddFarmer from 'app/farmer360/image-diagnosis/screens/AddFarmer'
import PriceRequest from 'app/screens/PriceRequest'
import NewRequest from 'app/screens/NewRequest'
import ChangePriceScreen from 'app/screens/ChangePriceScreen'
import RequestSuccessScreen from 'app/screens/RequestSuccessScreen'
import FarmersList from 'app/farmer360/screens/farmerList'
import OrderDetails from 'app/farmer360/screens/orderDetails'
import {
  ROUTES as KHETEDGE_ROUTES,
  SCREEN_NAMES as KHETEDGE_SCREEN_NAMES,
} from 'app/farmer360/KhetEdge/routes/types'
import Advisory from 'app/farmer360/KhetEdge/screens/advisory'
import KhetEdge from 'app/farmer360/KhetEdge/screens/khetEdge'

export const routesFarmer360: Record<
  string,
  { component: React.FC<any>; options?: NativeStackNavigationOptions }
> = {
  [FARMER_360_ROUTES.FARMER_360_HOME]: {
    component: Farmer360Home,
    options: {
      title: 'Farmer Profile',
    },
  },
  [FARMER_360_ROUTES.EDIT_FARMER_DETAILS]: {
    component: EditFarmerInfo,
    options: {
      title: 'Edit Farmer Info',
    },
  },
  [FARMER_360_ROUTES.ADD_FARMER_DETAILS]: {
    component: AddFarmerInfo,
    options: {
      title: 'Add Farmer Info',
    },
  },
  [FARMER_360_ROUTES.ORDERS_LISTING]: {
    component: OrdersListing,
    options: {
      title: 'Orders',
    },
  },
  [FARMER_360_ROUTES.ONGOING_CROPS_LISTING]: {
    component: OngoingCropsListing,
    options: {
      title: 'Ongoing Crops',
    },
  },
  [FARMER_360_ROUTES.FARMER_PRODUCTS_LISTING]: {
    component: FarmerProductListing,
    options: {
      title: FARMER_360_SCREEN_NAMES.FARMER_PRODUCTS_LISTING,
    },
  },
  [FARMER_360_ROUTES.START_DIAGNOSIS]: {
    component: StartDiagnosis,
    options: { headerShown: false },
  },
  [FARMER_360_ROUTES.DISEASE_DIAGNOSIS]: {
    component: DiseaseDiagnosisScreen,
    options: {
      title: 'Disease Diagnosis',
      headerRight: () => null,
    },
  },
  [FARMER_360_ROUTES.DISEASE_TREATMENT]: {
    component: DiseaseTreatment,
    options: {
      title: 'Disease Treatment',
      headerRight: () => null,
    },
  },
  [FARMER_360_ROUTES.DIAGNOSIS_RESULT]: {
    component: DiagnosisResult,
    options: {
      title: 'Diagnosis Results',
      headerRight: () => null,
    },
  },
  [FARMER_360_ROUTES.PREVIOUS_DIAGNOSIS]: {
    component: PreviousDiagnosis,
    options: {
      headerShown: false,
    },
  },
  [FARMER_360_ROUTES.ADD_FARMER]: {
    component: AddFarmer,
    options: {
      title: 'Add Farmer',
      headerRight: () => null,
    },
  },
  [FARMER_360_ROUTES.FARMERS_LIST]: {
    component: FarmersList,
    options: {
      title: 'Farmer List',
      headerRight: () => null,
    },
  },
  [FARMER_360_ROUTES.ORDER_DETAILS]: {
    component: OrderDetails,
    options: {
      title: 'Order Detail',
      headerRight: () => null,
    },
  },
}

export const routesKhetedge: Record<
  string,
  { component: React.FC<any>; options?: NativeStackNavigationOptions }
> = {
  [KHETEDGE_ROUTES.ADVISORY]: {
    component: Advisory,
    options: {
      title: KHETEDGE_SCREEN_NAMES.ADVISORY,
      headerRight: () => null,
    },
  },
  [KHETEDGE_ROUTES.KHET_EDGE]: {
    component: KhetEdge,
    options: {
      title: KHETEDGE_SCREEN_NAMES.KHET_EDGE,
      headerRight: () => null,
    },
  },
}

export const linking = (() => {
  const screens: Record<string, string> = {}
  screens[ROUTES.DASHBOARD] = ROUTES.DASHBOARD
  screens[ROUTES.REQUEST_TYPE] = ROUTES.REQUEST_TYPE
  screens[ROUTES.CHANGE_PRICE] = ROUTES.CHANGE_PRICE
  screens[ROUTES.NEW_REQUEST] = ROUTES.NEW_REQUEST
  screens[ROUTES.PRICE_REQUEST] = ROUTES.PRICE_REQUEST
  screens[ROUTES.DEMO_MATERIAL_REQUEST] = ROUTES.DEMO_MATERIAL_REQUEST
  screens[ROUTES.REQUEST_SUCCESS] = ROUTES.REQUEST_SUCCESS
  screens[ROUTES.DEMO_NEW_REQUEST] = ROUTES.DEMO_NEW_REQUEST
  screens[ROUTES.DEMO_PRODUCT_SELECTION] = ROUTES.DEMO_PRODUCT_SELECTION
  screens[ROUTES.DEMO_CREATE_REQUEST] = ROUTES.DEMO_CREATE_REQUEST
  screens[ROUTES.DEMO_REVIEW_REQUEST] = ROUTES.DEMO_REVIEW_REQUEST
  screens[ROUTES.DEMO_REQUEST_DETAIL] = ROUTES.DEMO_REQUEST_DETAIL
  Object.keys({
    ...routesFarmer360,
    ...routesKhetedge,
  }).forEach(route => {
    screens[route] = route
  })

  return {
    config: { screens },
    prefixes: [],
  }
})()
